import { combineReducers } from 'redux'
import MainReducer from './MainReducer'
import ChangeMenueReducer from './ChangeMenueReducer'
import TarhReducer from './TarhReducer'
import NameTarhReducer from './NameTarhReducer'
import BackToPanelReducer from './BackToPanelReducer'
import NavItemReducer from './NavItemReducer'


export default combineReducers({
    changeState: MainReducer,
    changeMenue: ChangeMenueReducer,
    TarhState:TarhReducer,
    NavItemState:NavItemReducer,
    NameTarhState:NameTarhReducer,
    BackToPanelState:BackToPanelReducer,

})